export const formatAccountWithoutDashes = (str: string) => {
  //removes internal dashes along with trailing spaces and dashes
  const cleanedStr = str.replace(/^[ -]+|[ -]+$|[-]/g, '')
  return cleanedStr
}
